import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + '/api';

export function getNextPlaces() {
    return axios.get(`${API_ENDPOINT}/tzadikims/upcoming-tzadikim`, { headers: getHeaderOptions() })
}

export function getNextPlacesUsingDate(startDate, endDate) {
    return axios.get(`${API_ENDPOINT}/tzadikims/upcoming-tzadikim-range?startDate=${startDate}&endDate=${endDate}`, { headers: getHeaderOptions() })
}